module.exports = __webpack_public_path__ + "img/gazosvarochnoe-oborudovanie.40623545.svg";